module.exports = __webpack_public_path__ + "img/gold_normal.da899c44.png";